// extracted by mini-css-extract-plugin
export var button = "_bg-7";
export var buttonRow = "_bg-6";
export var fadeIn = "_bg-1";
export var gradient = "_bg-0";
export var panel = "_bg-2";
export var panelIn = "_bg-3";
export var subtitle = "_bg-5";
export var title = "_bg-4";